<template>
    <div class="main">
        <div class="video_wrap">
            <span class="close" @click="close"><img src="./../../assets/icon22.png" alt=""></span>
            <video ref="video" style="width:100%" muted="muted" class="video"
                :src="videoUrl" type="video/mp4" controls="controls">
                <p>你的浏览器不支持video标签.</p>
            </video>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: {
        videoUrl: {
            default: "",
            type: String
        }
    },
    methods:{
        close(){
            this.$parent.showVideo = false
            this.$refs.video.pause()
        },
        
    }
}
</script>
<style scoped lang="scss">
.video_wrap{
    padding: 40px;
    background-color: #2d2d2d;
    // height: 500px;
    position: relative;
    video{
        height: 100%;
    }
    .close{
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        width: 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/fwzc/video.vue